import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './styles';

const AudioPlayer = ({ src }) => {
  const classes = useStyles();
  return (
    <audio controls className={classes.audio} controlsList="nodownload">
      <track kind="captions" />
      <source src={src} type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  );
};

AudioPlayer.propTypes = {
  src: PropTypes.string,
};

export default AudioPlayer;
